import { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";
import { deleteArchive, getArchive } from "../../../api/archives.api";
import ArchiveReader from "../../../components/archive/ArchiveReader";
import DownloadHistoryModal from "../../../components/archive/modals/DownloadHistoryModal";
import ErrorResponse from "../../../components/ErrorResponse";
import SimpleHeader from "../../../components/layout/SimpleHeader";
import Loader from "../../../components/Loader";
import useAxios from "../../../hooks/useAxios";
import useNotification from "../../../hooks/useNotification";
import { IGetArchive } from "../../../models/archives.model";

interface IMatch {
  archiveCode: string;
}

const ArchiveLearnRead = () => {
  const { t } = useTranslation();
  const match = useRouteMatch<IMatch>();
  const archiveCode = Number(match.params.archiveCode);
  const history = useHistory();
  const location = useLocation();
  const { successNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios<IGetArchive>();
  const { data: deleteRes, isLoading: deleteIsLoading, error: deleteError, execute: deleteExecute } = useAxios();

  const [downloadHistoryVisible, setDownloadHistoryVisible] = useState(false);

  useEffect(() => {
    if (archiveCode) {
      execute(getArchive('ST', archiveCode));
    }
  }, [archiveCode]);

  useEffect(() => {
    if (deleteRes && !deleteIsLoading) {
      successNotification(t('common.message.delete'));
      history.push(`/archive/learn${location.search}`);
    }
  }, [deleteRes, deleteIsLoading]);

  const onDelete = () => {
    if (!archiveCode) return;
    deleteExecute(deleteArchive('ST', archiveCode));
  }

  return (
    <div className="content scrollbar">
      {isLoading || deleteIsLoading ? <Loader /> : null}
      <ErrorResponse error={error} />
      <ErrorResponse error={deleteError} />
      <SimpleHeader
        iconFile="icon-archive-big.svg"
        parentMenu={t('common.menu.resources')}
        currentMenu={t('archive.learn.title2')}
      />
      <ArchiveReader
        codeId="BR0010"
        path="/archive/learn"
        archiveCode={archiveCode}
        data={res?.data}
        onDelete={onDelete}
        setDownloadHistoryVisible={setDownloadHistoryVisible}
      />

      <DownloadHistoryModal
        visible={downloadHistoryVisible}
        setVisible={setDownloadHistoryVisible}
        archiveGbn="ST"
        archiveCode={archiveCode}
      />
    </div>
  );
}

export default ArchiveLearnRead;
